// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'vend... Remove this comment to see the full error message
import createStore from 'vendor/cnpm/fluxible.v0-4/addons/createStore';

import { InvitationState, ResendStatus } from 'bundles/groups-invitation/constants/InvitationConstants';

const InvitationFlowStore = createStore({
  storeName: 'InvitationFlowStore',

  initialize() {
    this.reset();
  },

  getRedirectUrl() {
    return this.redirectUrl;
  },

  getErrorMessage() {
    return this.errorMessage;
  },

  getResendStatus() {
    return this.resendStatus;
  },

  getInvitationState() {
    return this.invitationState;
  },

  reset() {
    this.redirectUrl = undefined;
    this.errorMessage = undefined;
    this.resendStatus = ResendStatus.IDLE;
    this.invitationState = undefined;
  },
});

InvitationFlowStore.handlers = {
  SET_REDIRECT_URL({ redirectUrl }: $TSFixMe) {
    this.redirectUrl = redirectUrl;
    this.emitChange();
  },

  SET_ERROR_MESSAGE({ errorMessage }: $TSFixMe) {
    this.errorMessage = errorMessage;
    this.invitationState = InvitationState.ERROR_MESSAGE;
    this.emitChange();
  },

  SET_INVITATION_STATE({ invitationState }: $TSFixMe) {
    this.invitationState = invitationState;
    this.emitChange();
  },

  SET_RESEND_STATUS(resendStatus: $TSFixMe) {
    this.resendStatus = resendStatus;
    this.emitChange();
  },
};

export default InvitationFlowStore;
